<template>
    <div class="fixed z-[300] w-full h-full backdrop-blur-md"></div>
    <FormBlock class="match-event-form">
        <div class="match-event-form__title">Додати жовту картку</div>
        <div class="flex gap-[20px] justify-center">
            <div class="match-event-form__time">
                <div class="input-component__label">основний час</div>
                <div class="input-component__field time-field">
                    <input 
                        type="number"
                        class="text-center w-full"
                        :value="newGoal.mainTime"
                        @change="e => {newGoal.mainTime = e.target.value; newGoal.time = e.target.value}"
                    />
                </div>
            </div>
            <div class="match-event-form__time">
                <div class="input-component__label">додатковий час</div>
                <div class="input-component__field time-field">
                    <input 
                        type="number"
                        class="text-center w-full"
                        :value="newGoal.additionalTime"
                        @change="e => {newGoal.additionalTime = e.target.value; newGoal.time = +newGoal.mainTime + +e.target.value}"
                    />
                </div>
            </div>
        </div>

        <div class="match-event-form__our-goal-block h-[304px]">

            <div>
                <SelectComponent 
                    :label="'картка гравцю'" 
                    :options="teamNames" 
                    :name="'картка гравцю'" 

                    :default="newGoal.data.player.name"
                    @change="e => newGoal.data.player.name = e"
                />
            </div>

            <div class="match-event-form__details">
                <img src="@/assets/icons/yellow_card_icon.svg" class="w-[60px] mt-[20px]">
                <div>{{ newGoal.time }}’’ жовта картка - {{ newGoal.data.player.name }}</div>
            </div>

        </div>

        <div class="match-event-form__buttons">
            <ButtonComponent @click="save">
                Зберегти
            </ButtonComponent>
            <ButtonComponent @click="$emit('close')">
                Відмінити
            </ButtonComponent>
        </div>

    </FormBlock>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
    name: 'GoalForm',

    props: {
        team: {
            type: Array,
            default: () => []
        }
    },

    setup(props, { emit }) {
        const whoReleasedGoal = ref(true);
        const isPenalty = ref(false);

        const teamNames = ref(props.team.map(player => player.name))

        const newGoal = ref(
            {
                id: new Date().getTime(),
                type: 'YellowCard',
                time: 0,
                mainTime: 0,
                additionalTime: 0,
                data: {
                    player: {
                        name: 'Не вибрано'
                    }
                }
            }
        )

        const save = () => {
            emit('save', newGoal.value)
        }

        return {
            whoReleasedGoal,
            isPenalty,
            newGoal,
            teamNames,
            save
        }
    }
}
</script>

<style>
    
</style>